
import { toRefs, reactive, computed, defineComponent, getCurrentInstance, onMounted, nextTick } from 'vue'
import { useRoute, onBeforeRouteUpdate, RouteLocationNormalized } from 'vue-router'
import { useStore } from '@/store/index.ts'
import SubItem from '@/layout/navMenu/subItem.vue'
export default defineComponent({
  name: 'navMenuHorizontal',
  components: { SubItem },
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const { proxy } = getCurrentInstance() as any
    const route = useRoute()
    const store = useStore()
    const state: any = reactive({
      defaultActive: null
    })
    // 获取父级菜单数据
    const menuLists = computed(() => {
      return props.menuList
    })
    // 设置横向滚动条可以鼠标滚轮滚动
    const onElMenuHorizontalScroll = (e: any) => {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      proxy.$refs.elMenuHorizontalScrollRef.$refs.wrap.scrollLeft = proxy.$refs.elMenuHorizontalScrollRef.$refs.wrap.scrollLeft + eventDelta / 4
    }
    // 初始化数据，页面刷新时，滚动条滚动到对应位置
    const initElMenuOffsetLeft = () => {
      nextTick(() => {
        const els: any = document.querySelector('.el-menu.el-menu--horizontal li.is-active')
        if (!els) return false
        proxy.$refs.elMenuHorizontalScrollRef.$refs.wrap.scrollLeft = els.offsetLeft
      })
    }
    // 路由过滤递归函数
    const filterRoutesFun = (arr: Array<object>) => {
      return arr
        .filter((item: any) => !item.meta.isHide)
        .map((item: any) => {
          item = Object.assign({}, item)
          if (item.children) item.children = filterRoutesFun(item.children)
          return item
        })
    }
    // 传送当前子级数据到菜单中
    const setSendClassicChildren = (path: string) => {
      const currentPathSplit = path.split('/')
      const currentData: any = {}
      filterRoutesFun(store.state.routesList.routesList).map((v, k) => {
        if (v.path === `/${currentPathSplit[1]}`) {
          v.k = k
          currentData.item = [{ ...v }]
          currentData.children = [{ ...v }]
          if (v.children) currentData.children = v.children
        }
      })
      return currentData
    }
    // 设置页面当前路由高亮
    const setCurrentRouterHighlight = (currentRoute: any) => {
      const { path, meta } = currentRoute
      if (store.state.themeConfig.themeConfig.layout === 'classic') {
        state.defaultActive = `/${path.split('/')[1]}`
      } else {
        const pathSplit = meta.isDynamic ? meta.isDynamicPath.split('/') : path.split('/')
        if (pathSplit.length >= 4 && meta.isHide) state.defaultActive = pathSplit.splice(0, 3).join('/')
        else state.defaultActive = path
      }
    }
    // 页面加载时
    onMounted(() => {
      initElMenuOffsetLeft()
      setCurrentRouterHighlight(route)
    })
    // 路由更新时
    onBeforeRouteUpdate((to) => {
      // 修复：https://gitee.com/lyt-top/vue-next-admin/issues/I3YX6G
      setCurrentRouterHighlight(to)
      proxy.mittBus.emit('onMenuClick')
      // 修复经典布局开启切割菜单时，点击tagsView后左侧导航菜单数据不变的问题
      const { layout, isClassicSplitMenu } = store.state.themeConfig.themeConfig
      if (layout === 'classic' && isClassicSplitMenu) {
        proxy.mittBus.emit('setSendClassicChildren', setSendClassicChildren(to.path))
      }
    })
    return {
      menuLists,
      onElMenuHorizontalScroll,
      ...toRefs(state)
    }
  }
})
